//@flow

export default function makeDataProps(props: Object): Object {
  return Object.keys(props)
    .filter((prop) => prop.indexOf('data-') === 0)
    .reduce((r, prop) => {
      r[prop] = props[prop];
      return r;
    }, {});
}
